import { useMutation } from "convex/react";
import { useCallback } from "react";
import { useNavigate } from "react-router";

import { getRandomSampleDeckName } from "@/helpers/getRandomSampleDeckName";
import { useAllDecks } from "@/hooks/useAllDecks";
import { useReviewTime } from "@/hooks/useReviewTime";
import { api } from "@convex/_generated/api";

export function useAddSampleDeck() {
  const navigate = useNavigate();
  const decks = useAllDecks();
  const reviewTime = useReviewTime();
  const createSampleDeckMutation = useMutation(api.sampleDeck.createSampleDeck);

  return useCallback(async () => {
    const deckName = getRandomSampleDeckName(decks?.map((deck) => deck.name) ?? []);
    if (deckName !== undefined) {
      const { deckId } = await createSampleDeckMutation({ deckName, nextReview: reviewTime });
      void navigate(`/decks/${deckId}`);
    }
  }, [decks, createSampleDeckMutation, navigate, reviewTime]);
}
